import { render, staticRenderFns } from "./WonderStrategyDetail.vue?vue&type=template&id=56f89464&scoped=true"
import script from "./WonderStrategyDetail.vue?vue&type=script&lang=js"
export * from "./WonderStrategyDetail.vue?vue&type=script&lang=js"
import style0 from "./WonderStrategyDetail.vue?vue&type=style&index=0&id=56f89464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f89464",
  null
  
)

export default component.exports